export const BASE_URL =
  process.env.REACT_APP_BASE_URL ||
  'https://backend-fcfm-profesores-hub.fly.dev/';
